import { Component } from '@angular/core';

@Component({
  standalone: true,
  templateUrl: './auth-fallback.html',
  styleUrl: './auth-fallback.css',
})
export class AuthFallbackComponent {}
